import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import DateFnsAdapter from "@material-ui/pickers/adapter/date-fns";
import enLocale from "date-fns/locale/en-US";
import React, { FC, useState } from "react";
import { DatePicker as MUIDatePicker, DatePickerProps, LocalizationProvider } from "@material-ui/pickers";

import BaseInput from "../BaseInput";

const DatePicker: FC<DatePickerProps> = ({ value, onChange, InputProps, label, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClickAway = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <LocalizationProvider dateAdapter={DateFnsAdapter} locale={enLocale}>
          <MUIDatePicker
            open={isOpen}
            onClose={handleClose}
            onOpen={handleOpen}
            InputProps={InputProps}
            label={label}
            value={value}
            onChange={onChange}
            renderInput={(props) => <BaseInput variant="outlined" {...props} />}
            disabled={disabled}
          />
        </LocalizationProvider>
      </div>
    </ClickAwayListener>
  );
};

export default DatePicker;
